import * as React from 'react';
import { OTPMFATestWidget } from '../OTPFactorTestWidget';
import { ConfigureMFANavigationAction } from '../../ConfigureMFADialog';
import { styled } from '../../../../../../theme';

export type AuthenticatorTestWidgetProps = {
  factorId: string;
  back: ConfigureMFANavigationAction;
  next: ConfigureMFANavigationAction;
  onCancel: ConfigureMFANavigationAction;
};

export const AUTHENTICATOR_OTP_CODE_LENGTH = 6;

namespace S {
  const BASE_LABEL = 'authenticator-mfa-test-widget';

  export const Message = styled.div`
    label: ${BASE_LABEL}-message;
    font-size: 14px;
    color: ${(p) => p.theme.text.secondary};
    text-align: center;
  `;
}

export const AuthenticatorMFATestWidget: React.FC<AuthenticatorTestWidgetProps> = (props) => {
  return (
    <OTPMFATestWidget
      otpLength={AUTHENTICATOR_OTP_CODE_LENGTH}
      pendingValidationContent={() => <S.Message>Enter an OTP code from your authenticator app</S.Message>}
      {...props}
    />
  );
};
